<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="booking"
>
  <div
    class="mb-4"
    *ngIf="[BookingCreationType.DEFAULT].includes(selectedBookingCreateType)"
  >
    <label class="form-label">
      {{ 'productModule.activity' | translate }}
    </label>

    <product-select-input
      (search)="onSearchProducts($event)"
      [products]="allowAsLinkedChildProducts$ | async"
      formControlName="linkedProductId"
      [allowClearing]="!courseProduct"
      [isFromBookingSaleCreation]="true"
      [isDisabled]="!!courseProduct"
      [courseProduct]="courseProduct"
      data-test-id="select-activity-create-booking"
    ></product-select-input>
  </div>
  <div
    class="mb-4"
    *ngIf="
      [BookingCreationType.MULTI_ACTIVITY].includes(selectedBookingCreateType)
    "
  >
    <label class="form-label">
      {{ 'bookingModule.potentialActivities' | translate }}</label
    >

    <product-select-input-multiple
      (search)="onSearchProducts($event)"
      [products]="allowAsLinkedChildProducts$ | async"
      formControlName="allowedLinkedProductIds"
      [allowClearing]="true"
    ></product-select-input-multiple>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.allowedLinkedProductIds.dirty &&
        form.controls.allowedLinkedProductIds.invalid
      "
    >
      {{
        'productModule.mustSelectMoreThenOneAllowedLinkedProduct' | translate
      }}
    </p>
  </div>
  <div class="mb-4">
    <label class="form-label">
      {{ 'productModule.resource' | translate }}
    </label>

    <ng-select
      data-test-id="select-resource-create-booking"
      [readonly]="
        createBookingFromSchedule ||
        ([BookingCreationType.DEFAULT].includes(selectedBookingCreateType) &&
          !form.controls['linkedProductId'].value) ||
        ([BookingCreationType.MULTI_ACTIVITY].includes(
          selectedBookingCreateType
        ) &&
          !form.controls['allowedLinkedProductIds'].value)
      "
      [clearSearchOnAdd]="true"
      [items]="bookableProducts$ | async"
      [multiple]="true"
      [searchable]="true"
      bindLabel="description"
      [virtualScroll]="true"
      bindValue="id"
      formControlName="productIds"
      [closeOnSelect]="true"
      (change)="changeProductIds($event)"
      (search)="onSearchAllowedLinkedProduct($event)"
      aria-describedby="resourceError"
    >
    </ng-select>

    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      id="resourceError"
      *ngIf="form.controls.productIds.dirty && form.controls.productIds.invalid"
    >
      {{ 'productModule.resource' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <div class="mb-4" *ngIf="location$ | async as location">
    <label class="form-label">
      {{ 'locationModule.location' | translate }}
    </label>
    <p>{{ location?.description }}</p>
  </div>
  <div class="mb-4" *ngIf="showApplyYearCalendar">
    <fieldset>
      <legend class="form-label">
        {{ 'bookingModule.applyYearCalendar' | translate }}
      </legend>
      <div class="input-group">
        <div class="btn-group-segment bg-light btn-group-pills">
          <input
            type="radio"
            class="btn-check"
            value="{{ true }}"
            id="applyYearMatrixbtnradio1"
            (click)="applyYearMatrix(true)"
            [checked]="wantApplyYearMatrix"
          />
          <label
            class="btn"
            for="applyYearMatrixbtnradio1"
            data-test-id="apply-year-matrix-yes"
          >
            {{ 'general.yes' | translate }}
          </label>

          <input
            type="radio"
            class="btn-check"
            id="applyYearMatrixbtnradio2"
            (click)="applyYearMatrix(false)"
            value="{{ false }}"
            [checked]="!wantApplyYearMatrix"
          />
          <label
            class="btn"
            for="applyYearMatrixbtnradio2"
            data-test-id="apply-year-matrix-no"
          >
            {{ 'general.no' | translate }}
          </label>
        </div>
      </div>
    </fieldset>
  </div>

  <fieldset class="mb-4">
    <legend class="form-label">
      {{ 'bookingModule.startTime' | translate }}
    </legend>
    <datetime-input
      formControlName="startDate"
      (currentData)="setDates($event)"
      class="flex-nowrap"
      (currentDataValue)="patchStartDate($event)"
    ></datetime-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      id="startTimeError"
      *ngIf="form.controls.startDate.dirty && form.controls.startDate.invalid"
    >
      {{ 'bookingModule.startTime' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </fieldset>

  <div class="mb-4">
    <fieldset>
      <legend class="form-label">{{
        'bookingModule.setEndTime' | translate
      }}</legend>
      <div class="btn-group btn-group-toggle flex-wrap">
        <button
          class="btn btn-soft-primary btn-sm"
          [ngClass]="{
            active: selectedEndTimeSlot === endTimeSlot.PRODUCT_SLOT_SIZE
          }"
          type="button"
          (click)="setEndDate(endTimeSlot.PRODUCT_SLOT_SIZE)"
        >
          {{ 'bookingModule.slotSize' | translate }}
        </button>
        <button
          class="btn btn-soft-primary btn-sm"
          [ngClass]="{
            active: selectedEndTimeSlot === endTimeSlot.ONE_HOUR
          }"
          type="button"
          (click)="setEndDate(endTimeSlot.ONE_HOUR)"
        >
          {{ 'bookingModule.oneHour' | translate }}
        </button>
        <button
          class="btn btn-soft-primary btn-sm"
          [ngClass]="{
            active: selectedEndTimeSlot === endTimeSlot.ONE_AND_HALF_HOURS
          }"
          type="button"
          (click)="setEndDate(endTimeSlot.ONE_AND_HALF_HOURS)"
        >
          {{ 'bookingModule.oneAndHalfHours' | translate }}
        </button>

        <button
          class="btn btn-soft-primary btn-sm"
          [ngClass]="{
            active: selectedEndTimeSlot === endTimeSlot.TWO_HOURS
          }"
          type="button"
          (click)="setEndDate(endTimeSlot.TWO_HOURS)"
        >
          {{ 'bookingModule.twoHours' | translate }}
        </button>

        <button
          [className]="
            selectedEndTimeSlot === endTimeSlot.CUSTOM
              ? 'btn btn-soft-primary btn-sm active'
              : 'btn btn-soft-primary btn-sm'
          "
          type="button"
          (click)="setEndDate(endTimeSlot.CUSTOM)"
        >
          {{ 'bookingModule.custom' | translate }}
        </button>
      </div>
    </fieldset>
  </div>

  <fieldset class="mb-4" [hidden]="selectedEndTimeSlot !== endTimeSlot.CUSTOM">
    <legend class="form-label">
      {{ 'general.endTime' | translate }}
    </legend>

    <datetime-input
      formControlName="endDate"
      (currentData)="patchEndDate($event)"
    ></datetime-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      id="endTimeError"
      *ngIf="form.controls.endDate.dirty && form.controls.endDate.invalid"
    >
      {{ 'general.endTime' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </fieldset>
  <div class="mb-4">
    <fieldset>
      <legend class="form-label">
        {{ 'bookingModule.needToRepeat' | translate }}
      </legend>

      <div class="btn-group-segment bg-light btn-group-pills">
        <input
          type="radio"
          class="btn-check"
          name="repeatBooking"
          value="{{ true }}"
          (click)="openModalRepeatbookings(true)"
          id="repeatBookingYesbtnradio1"
          autocomplete="off"
          [checked]="repeatBooking"
          [disabled]="!disableRepeatBookingButtons"
        />
        <label
          class="btn"
          for="repeatBookingYesbtnradio1"
          data-test-id="repeat-booking-select-button-yes"
        >
          {{ 'general.yes' | translate }}
        </label>

        <input
          type="radio"
          class="btn-check"
          name="repeatBooking"
          id="repeatBookingNobtnradio2"
          value="{{ false }}"
          (click)="openModalRepeatbookings(false)"
          autocomplete="off"
          [checked]="!repeatBooking"
          [disabled]="!disableRepeatBookingButtons"
        />
        <label
          class="btn"
          for="repeatBookingNobtnradio2"
          data-test-id="form-create-booking-select-repeat-booking-select-button-no"
        >
          {{ 'general.no' | translate }}
        </label>
      </div>
      <button
        *ngIf="!showRepeatForm && repeatBooking"
        type="button"
        class="btn btn-sm btn-ghost-primary"
        (click)="$event.preventDefault(); openModalRepeatbookings(true)"
      >
        {{ 'general.edit' | translate }}
      </button>
    </fieldset>
    <div *ngIf="showRepeatForm" class="card p-3 mt-4">
      <booking-form-repeat
        [cleanFormData]="false"
        [wantApplyYearCalendar]="wantApplyYearMatrix"
        [selectedForm]="setSelectedFormInBooKingFormRepeat()"
        [showSubmitButton]="false"
        [booking]="bookingOfRepeatFormRepeat"
        [form]="formOfRepeatFormRepeat"
        [resetRepeatForm$]="resetRepeatForm$"
        [partialBookingForm]="form"
        [isModal]="false"
        (onCancel)="clickOnCancelButton()"
        (onClickSaveModal)="clickOnSaveButton($event)"
      >
      </booking-form-repeat>
    </div>
  </div>
  <div
    class="mb-4"
    *ngIf="
      [BookingCreationType.DEFAULT].includes(selectedBookingCreateType) &&
      form.controls['linkedProductId'].value
    "
  >
    <label class="form-label">
      {{ 'bookingModule.colorInAP' | translate }}
    </label>
    <div class="d-flex">
      <input class="form-control" formControlName="colour" type="color" />
      <button
        type="button"
        class="btn btn-ghost-primary ms-2"
        (click)="$event.preventDefault(); toggleColorByDefault()"
      >
        {{ 'bookingModule.returnsDefaultColor' | translate }}
      </button>
    </div>
  </div>
  <div class="mb-4" *ngIf="selectedBookingCreateType == 0">
    <fieldset>
      <legend class="form-label">
        {{ 'bookingModule.assignSupervisor' | translate }}
      </legend>

      <div class="btn-group-segment bg-light btn-group-pills">
        <input
          type="radio"
          class="btn-check"
          name="assignSupervisor"
          value="{{ true }}"
          (click)="openModalAssignSupervisor(true)"
          id="assignSupervisorYesbtnradio1"
          autocomplete="off"
          [checked]="assignSupervisor"
          [disabled]="!disableAssignSupervisorButtons"
          aria-describedby="productIdsError"
        />
        <label
          class="btn"
          for="assignSupervisorYesbtnradio1"
          data-test-id="create-booking-assing-supervisor-button-option"
        >
          {{ 'general.yes' | translate }}
        </label>

        <input
          type="radio"
          class="btn-check"
          name="assignSupervisor"
          id="assignSupervisorNobtnradio2"
          value="{{ false }}"
          (click)="openModalAssignSupervisor(false)"
          autocomplete="off"
          [checked]="!assignSupervisor"
          [disabled]="!disableAssignSupervisorButtons"
          aria-describedby="productIdsError"
        />
        <label class="btn" for="assignSupervisorNobtnradio2">
          {{ 'general.no' | translate }}
        </label>
      </div>
    </fieldset>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      id="productIdsError"
      *ngIf="form.controls?.productIds?.value?.length != 1"
    >
      <strong>{{ 'alerts.adjustResource' | translate }}</strong>
    </p>
    <div class="mt-2 text-dark">
      {{
        arraySupervisors
          | extractKey: 'personId'
          | getFirstAndSecondName
          | async
      }}
    </div>
  </div>
  <div>
    <button
      type="button"
      class="btn btn-ghost-primary btn-sm"
      (click)="showHideSection()"
      aria-controls="moreSection"
      >{{
        !showHideFields
          ? ('general.showMore' | translate)
          : ('general.showLess' | translate)
      }}</button
    >
  </div>
  <!-- hide section-->

  <fieldset *ngIf="showHideFields" id="moreSection" class="mt-3">
    <div class="mb-4">
      <label class="form-label">
        {{ 'bookingModule.maxParticipants' | translate }}
        <strong *ngIf="getParticipants$() | async"
          >[ {{ getParticipants$() | async }} ]</strong
        >
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'bookingModule.maxParticipantsTooltip' | translate"
        ></i>
      </label>
      <input
        class="form-control"
        type="number"
        formControlName="maxParticipants"
        [attr.aria-invalid]="
          form.controls.maxParticipants.dirty &&
          form.controls.maxParticipants.invalid
            ? 'true'
            : null
        "
      />
    </div>
    <div class="mb-4">
      <label class="form-label">
        {{ 'bookingModule.publicStatus' | translate }}
      </label>

      <select
        formControlName="status"
        class="form-select"
        [attr.aria-invalid]="
          form.controls.status.dirty && form.controls.status.invalid
            ? 'true'
            : null
        "
      >
        <option
          *ngFor="let bookingStatusValue of bookingStatus"
          [value]="bookingStatusValue.value"
        >
          {{
            'bookingModule.bookingStatus' + bookingStatusValue.value | translate
          }}
        </option>
      </select>
    </div>

    <div class="mb-4">
      <label class="form-label">
        {{ 'bookingModule.series' | translate }}
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'bookingModule.seriesTooltip' | translate"
        ></i>
      </label>

      <input
        class="form-control"
        type="text"
        maxlength="255"
        formControlName="serieId"
        [attr.aria-invalid]="
          form.controls.serieId.dirty && form.controls.serieId.invalid
            ? 'true'
            : null
        "
      />
    </div>
    <div class="mb-4">
      <label class="form-label">
        {{ 'bookingModule.description' | translate }}
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'bookingModule.descriptionTooltip' | translate"
        ></i>
      </label>
      <input
        class="form-control"
        type="text"
        maxlength="255"
        formControlName="description"
        [attr.aria-invalid]="
          form.controls.description.dirty && form.controls.description.invalid
            ? 'true'
            : null
        "
      />
    </div>

    <div class="mb-4">
      <label class="form-label">
        {{ 'bookingModule.memo' | translate }}
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          tabindex="0"
          [tooltip]="'bookingModule.memoTooltip' | translate"
        ></i>
      </label>

      <textarea
        class="form-control"
        formControlName="memo"
        rows="3"
        [attr.aria-invalid]="
          form.controls.memo.dirty && form.controls.memo.invalid ? 'true' : null
        "
      ></textarea>
    </div>
  </fieldset>
</form>
